export default "__VITE_ASSET__6_v_Bdfy__"